// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1JWuB","errorLogs":"EditorFooter_errorLogs__1SpA5"};